
  import { Component, Vue } from "vue-property-decorator";
  import {
    GetReportQrcode,
    GetReportData,
    GetReportList,
    HtmlToPdf
  } from "@/request/common";
  import QrcodeVue from "qrcode.vue";
  const Config = (require("/public/setting") as any).Config;
  
  @Component({
    components: {
      QrcodeVue,
    },
  })
  export default class Report extends Vue {
    private report_id: any = "";
    private beforeDate: any = {};
    private data: any = {
      tongue_images: {},
      deepseek_result: "",
      extra_text: "",
      report_result: {},
    };
    private loading = false;
    private qrcodeUrl: string = "";
    private loadingText: string = "";
    private get systemInfo() {
      return this.$store.state.systemInfo;
    }
    private getText(key: string) {
      const resultText = this.data.tongue_result_text;
      const regexMap: { [key: string]: RegExp } = {
        舌色: /舌色：([^，]+)/,
        边尖红: /边尖红：([^，]+)/,
        瘀斑瘀点: /瘀斑瘀点：([^，]+)/,
        苔色: /苔色：([^，]+)/,
        苔厚薄: /苔厚薄：([^，]+)/,
        苔腻: /苔腻：([^，]+)/,
        苔腐: /苔腐：([^，]+)/,
        苔剥: /苔剥：([^，]+)/,
        舌胖瘦: /舌胖瘦：([^，]+)/,
        齿痕: /齿痕：([^，]+)/,
        点刺: /点刺：([^，]+)/,
        裂纹: /裂纹：([^，]+)/,
      };
  
      const regex = regexMap[key];
      if (regex) {
        const match = resultText.match(regex);
        return match ? match[1] : "";
      }
      return "";
    }
    private goToHome() {
      this.$router.push("/");
    }
    private getTextAll() { }
    private getReportQrcode() {
      console.log(Config);
      const params = {
        params: {
          page_path: `${Config.GLOBAL_API_ROOT}#/report`,
        },
      };
  
      GetReportQrcode(this, this.report_id, params)
        .then((res: any) => {
          console.log("后端返回的响应:", res);
          // 直接创建 Blob 对象
          const blob = new Blob([res], { type: "image/png" });
          console.log("创建的blob:", blob);
          // 创建 URL
          this.qrcodeUrl = URL.createObjectURL(blob);
          console.log("生成的URL:", this.qrcodeUrl);
        })
        .catch((error) => {
          console.error("获取二维码出错:", error);
        });
    }
    private goToPdf() {
      this.loadingText = 'PDF转换中......';
      this.loading = true;
      const params = {
        // url: 'https://szr.medkg.cn/#/report?report_id=109&ifCanReturn=true',
        url: window.location.href,
      };
      HtmlToPdf(this, params).then((res: any) => {
        this.loading = false;
        this.loadingText = '';
        console.log("下载PDF:", res);
        window.open(res.pdf_url);
      });
  
    }
    beforeDestroy() {
      // 组件销毁时清理 URL，避免内存泄漏
      if (this.qrcodeUrl) {
        URL.revokeObjectURL(this.qrcodeUrl);
      }
    }
  
    private getReportData() {
      GetReportData(this, this.report_id).then((res: any) => {
        this.data = res;
        console.log("数据");
        console.log(this.data);
        this.getBeforeReport();
        this.getReportQrcode();
      });
    }
    private getBeforeReport() {
      const params: any = {
        params: {
          before_report_id: this.report_id,
        },
      };
      GetReportList(this, params).then((res: any) => {
        if (res.length > 0) {
          this.beforeDate = res[0];
        } else {
          this.beforeDate = {};
        }
      });
    }
  
    mounted() {
      if (this.$route.query.report_id) {
        this.report_id = this.$route.query.report_id;
        this.getReportData();
      }
    }
  }
  